import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import iziToast from "izitoast";
import { useContext, useState } from "react";
import { AppAgentContext } from "src/context/ContextProvider";
import useAsyncEffect from "src/hooks/useAsyncEffect";
import { upsertAgentService } from "src/services/AgentService";
import { createFolderService, deleteFileService, getFolderFilesService, uploadFileCompressedService } from "src/services/AssetService";
import { appActions, DataStates, State } from "src/store";
import { AiAgent } from "src/types/AiAgent";
import { ModalType } from "src/types/Modal";
import { formatSizeUnits, typeFileComponent } from "src/utils";
import { v4 as uuidv4 } from 'uuid';
import { DragAndDrop, FileProps, imageFileComponent } from '../../shared/DragAndDrop';
import { AiAgentActions, AiAgentContext } from "./AgentDetailPageComponent";

export const AgentKnowledgeComponent = () => {

  const [filesComponent, setFilesComponent] = useState<FileProps[]>([]);
  const [files, setFiles] = useState<File[]>([]);
  const { state: {session: { ai_agent_config: 
    { file_types = ['pdf'], text_url = { web: false, video: false, audio: false}, folders: { knowledge = ''} }}}
    , dispatch: dispatchApp } = useContext(AppAgentContext);
  const { state: { ai_agent }, dispatch } = useContext(AiAgentContext);
  const [values, setValues] = useState({ website: '', audio: '', video: ''});

  useAsyncEffect(async() => {
    if(files.length > 0) {
        if(ai_agent.getKnowledge().length > 0) {
          const res = await uploadFileCompressedService(ai_agent.getKnowledge(), files);
          if(res.success) {
            const itemsKey = typeFileComponent(filesComponent, res.items);
            setFilesComponent(itemsKey);
            dispatch(AiAgentActions.setFinalFiles(itemsKey));
          }
        } else {
          const resp = await createFolderService(knowledge, uuidv4());
          if(resp) {
              const folderKey = resp.folder.key;
              const agent = new AiAgent(ai_agent);
              agent.setKnowledge(folderKey);
              dispatch(AiAgentActions.setAiAgent(agent));      
              const res = await uploadFileCompressedService(folderKey, files);
              if(res.success) {
                const itemsKey = typeFileComponent(filesComponent, res.items);
                setFilesComponent(itemsKey);
                dispatch(AiAgentActions.setFinalFiles(itemsKey));
              }
          }
        }
    }
  }, [files]);

  useAsyncEffect(async() => {
    if(ai_agent.getKnowledge()) {
      if(ai_agent.getKnowledge().length > 0) {
        const response = await getFolderFilesService(ai_agent.getKnowledge());
        if(response.success) {
          // console.log('response', response);
          const filesUp = response.items.map(item => ({
            key: item.key,
            name: item.name,
            type: item.mimetype,
            size: item.size,
          }));
          // const filesUrl = await urltoFileProps(Agent.url_video, file_types);
          setFilesComponent(filesUp);
          dispatch(AiAgentActions.setInitialFiles(filesUp));
          dispatch(AiAgentActions.setFinalFiles(filesUp));
        }
      }
    }
  }, []);

  const deleteFileFolder = (file: FileProps) => {
    dispatchApp(appActions.openModal({
      type: ModalType.CONFIRMATION,
      data: {
        title: 'Archivo',
        description: '¿Estas seguro de eliminar el archivo?',
        state: DataStates.AGENT,
        async onConfirm() {
          dispatchApp(appActions.onLoading({type: DataStates.AGENT, status: State.LOADING}));
            const res = await deleteFileService(file.key ?? '0');
            if(res.success) {
              iziToast.success({
                message: 'Archivo Eliminado',
                position: 'topCenter'
              });
              setFilesComponent((prevFiles) => prevFiles.filter(fi => fi.key !== file.key));
              dispatch(AiAgentActions.setFinalFiles(filesComponent.filter(fi => fi.key !== file.key)));
              dispatchApp(appActions.onLoading({type: DataStates.AGENT, status: State.SUCCESS}));
              dispatchApp(appActions.closeModal(ModalType.CONFIRMATION));
            }
        },
        onClose() {
          dispatchApp(appActions.closeModal(ModalType.CONFIRMATION));
        },
      }
    }));
  }
  const deleteUrl = (data: string, type: 'url_audio' | 'url_web' | 'url_video') => {
    const title = type === 'url_web' ? 'Sitio Web' : type === 'url_audio' ? 'Audio' : 'Video';
    const urls = type === 'url_web' ? ai_agent.getUrlWeb() : type === 'url_audio' ? ai_agent.getUrlAudio() : ai_agent.getUrlVideo();
    dispatchApp(appActions.openModal({
      type: ModalType.CONFIRMATION,
      data: {
        title,
        description: `¿Estas seguro de eliminar el ${title.toLowerCase()}?`,
        state: DataStates.AGENT,
        async onConfirm() {
          dispatchApp(appActions.onLoading({type: DataStates.AGENT, status: State.LOADING}));
          const deleteUrl = urls.filter(url => url !== data);
          const agent = new AiAgent(ai_agent);
          switch(type) {
            case "url_audio":
              agent.setUrlAudio(deleteUrl);
              break;
            case "url_web":
              agent.setUrlWeb(deleteUrl);
              break;
            case "url_video":
              agent.setUrlVideo(deleteUrl);
              break;
          }
          const res = await upsertAgentService(agent);
          if(res.success) {
            iziToast.success({
              message: `${title} Eliminado`,
              position: 'topCenter'
            });
            dispatch(AiAgentActions.setAiAgent(agent));
            dispatchApp(appActions.onLoading({type: DataStates.AGENT, status: State.SUCCESS}));
            dispatchApp(appActions.closeModal(ModalType.CONFIRMATION));
          } else {
            dispatchApp(appActions.onLoading({type: DataStates.AGENT, status: State.ERROR}));
          }
        },
        onClose() {
          dispatchApp(appActions.closeModal(ModalType.CONFIRMATION));
        },
      }
    }));
  }

  return (
    <div className="p-5">
      <div className="">
        <div className="w-full">
          <div className="grid gap-1 items-center mb-3">
              <label htmlFor="">Subir archivos</label>
              <DragAndDrop 
                fileTypes={file_types}
                setFilesComponent={setFilesComponent}
                setFiles={setFiles}
              />
          </div>
          <div className="grid gap-1 items-center mb-5">
            <h2>Archivos Incluidos</h2>
            <div className="flex flex-wrap gap-5 my-2 ">
                  {filesComponent.map((file, index) => (
                      <div key={index} className="relative flex gap-5">
                          <div>
                              {imageFileComponent(file)}
                          </div>

                          <div>
                              <p>{file.name}</p>
                              <p>{formatSizeUnits(file.size)}</p>
                          </div>

                          <div>
                              <span
                                  className="cursor-pointer text-red-400 w-5 h-5 flex justify-center items-center"
                                  onClick={() => deleteFileFolder(file)}
                              >
                                  <FontAwesomeIcon icon={faTimesCircle as any} />
                              </span>
                          </div>
                          
                      </div>
                  ))}
                  {
                    filesComponent.length === 0 && (
                      <p className="text-gray-300">Sin archivos</p>
                    )
                  }
              </div>
          </div>
          {
            text_url.web && (
              <>
                <div className="grid gap-1 items-center mb-5">
                  <label htmlFor="">Sitios Web</label>
                  <div className="flex gap-2">
                    <input
                        type="text"
                        autoComplete={'off'}
                        value={values.website}
                        className="py-2 px-4 w-full rounded border border-gray-400 outline-none resize-none"
                        placeholder="https://example.com"
                        onKeyDown={(event) => {
                          if(event.key === 'Enter') {
                            event.preventDefault();
                            const agent = new AiAgent(ai_agent);
                            agent.setUrlWeb([...agent.getUrlWeb(), values.website]);
                            dispatch(AiAgentActions.setAiAgent(agent));
                            setValues(prev => ({...prev, website: ''}));
                            // dispatch(AiAgentActions.setAgent({...Agent, website: '', url_web: [...Agent.url_web, Agent.website]}))
                          }
                        }}
                        onChange={(event) => {
                          setValues(prev => ({...prev, website: event.target.value}));
                        }}
                    />
                    <div className="w-20">
                      <button className="flex btn btn-sm h-full items-center" type="button" onClick={() => {
                        const agent = new AiAgent(ai_agent);
                        agent.setUrlWeb([...agent.getUrlWeb(), values.website]);
                        dispatch(AiAgentActions.setAiAgent(agent));
                        setValues(prev => ({...prev, website: ''}));
                      }}>
                        + Añadir
                      </button>
                    </div>
                  </div>
                </div>
                <div className="grid gap-1 items-center mb-5">
                  <h2>Sitios Web Incluidos</h2>
                  <div className="flex flex-wrap gap-3 my-2">
                    {
                      ai_agent.getUrlWeb().map((website, index) => (
                        <div key={index} className="p-2 border border-gray-400 rounded flex gap-4">
                          <p className="text-sm">{website}</p>
                          <span
                              className="cursor-pointer text-red-400 w-5 h-5 flex justify-center items-center"
                              onClick={() => deleteUrl(website, 'url_web')}
                          >
                              <FontAwesomeIcon icon={faTimesCircle as any} />
                          </span>
                        </div>
                      ))
                    }
                    {
                      ai_agent.getUrlWeb().length === 0 && (
                        <p className="text-gray-300">Sin sitios web</p>
                      )
                    }
                  </div>
                </div>
              </>
            )
          }
          {
            text_url.audio && (
              <>
                <div className="grid gap-1 items-center mb-5">
                  <label htmlFor="">Audios</label>
                  <div className="flex gap-2">
                    <input
                        type="text"
                        autoComplete={'off'}
                        value={values.audio}
                        className="py-2 px-4 w-full rounded border border-gray-400 outline-none resize-none"
                        placeholder="https://example.com"
                        onKeyDown={(event) => {
                          if(event.key === 'Enter') {
                            event.preventDefault();
                            const agent = new AiAgent(ai_agent);
                            agent.setUrlAudio([...agent.getUrlAudio(), values.audio]);
                            dispatch(AiAgentActions.setAiAgent(agent));
                            setValues(prev => ({...prev, audio: ''}));
                          }
                        }}
                        onChange={(event) => {
                          setValues(prev => ({...prev, audio: event.target.value}));
                        }}
                    />
                    <div className="w-20">
                      <button className="flex btn btn-sm h-full items-center" type="button" onClick={() => {
                        const agent = new AiAgent(ai_agent);
                        agent.setUrlAudio([...agent.getUrlAudio(), values.audio]);
                        dispatch(AiAgentActions.setAiAgent(agent));
                        setValues(prev => ({...prev, audio: ''}));
                      }}>
                        + Añadir
                      </button>
                    </div>
                  </div>
                </div>
                <div className="grid gap-1 items-center mb-5">
                  <h2>Audios Incluidos</h2>
                  <div className="flex flex-wrap gap-3 my-2">
                    {
                      ai_agent.getUrlAudio().map((audio, index) => (
                        <div key={index} className="p-2 border border-gray-400 rounded flex gap-4">
                          <p className="text-sm">{audio}</p>
                          <span
                              className="cursor-pointer text-red-400 w-5 h-5 flex justify-center items-center"
                              onClick={() => deleteUrl(audio, 'url_audio')}
                          >
                              <FontAwesomeIcon icon={faTimesCircle as any} />
                          </span>
                        </div>
                      ))
                    }
                    {
                      ai_agent.getUrlAudio().length === 0 && (
                        <p className="text-gray-300">Sin audios</p>
                      )
                    }
                  </div>
                </div>
              </>
            )
          }
          {
            text_url.video && (
              <>
                <div className="grid gap-1 mb-5">
                  <label htmlFor="">Videos</label>
                  <div className="flex gap-2">
                    <input
                        type="text"
                        autoComplete={'off'}
                        value={values.video}
                        className="py-2 px-4 w-full rounded border border-gray-400 outline-none resize-none"
                        placeholder="https://example.com"
                        onKeyDown={(event) => {
                          if(event.key === 'Enter') {
                            event.preventDefault();
                            const agent = new AiAgent(ai_agent);
                            agent.setUrlVideo([...agent.getUrlVideo(), values.video]);
                            dispatch(AiAgentActions.setAiAgent(agent));
                            setValues(prev => ({...prev, video: ''}));
                          }
                        }}
                        onChange={(event) => {
                          setValues(prev => ({...prev, video: event.target.value}));
                        }}
                    />
                    <div className="w-20">
                      <button className="flex btn btn-sm h-full items-center" type="button" onClick={() => {
                        const agent = new AiAgent(ai_agent);
                        agent.setUrlVideo([...agent.getUrlVideo(), values.video]);
                        dispatch(AiAgentActions.setAiAgent(agent));
                        setValues(prev => ({...prev, video: ''}));
                      }}>
                        + Añadir
                      </button>
                    </div>
                  </div>
                </div>
                <div className="grid gap-1 items-center">
                  <h2>Videos Incluidos</h2>
                  <div className="flex flex-wrap gap-3 my-2">
                    {
                      ai_agent.getUrlVideo().map((video, index) => (
                        <div key={index} className="p-2 border border-gray-400 rounded flex gap-4">
                          <p className="text-sm">{video}</p>
                          <span
                              className="cursor-pointer text-red-400 w-5 h-5 flex justify-center items-center"
                              onClick={() => deleteUrl(video, 'url_video')}
                          >
                              <FontAwesomeIcon icon={faTimesCircle as any} />
                          </span>
                        </div>
                      ))
                    }
                    {
                      ai_agent.getUrlVideo().length === 0 && (
                        <p className="text-gray-300">Sin videos</p>
                      )
                    }
                  </div>
                </div>
              </>
            )
          }
        </div>
      </div>
    </div>
  )
}
